import './LoadingOverlay.scss';
import cn from 'classnames';
import { PropsWithChildren } from 'react';
import { Spinner } from '../Spinner';

interface LoadingOverlayProps extends PropsWithChildren {
  message?: string;
  spinnerSize?: number;
  className?: string;
}

// Layers an animated spinner and message over placeholder content (e.g. a
// Skeleton) so users get an explicit "still working" signal while data loads.
export const LoadingOverlay = ({
  message = 'Loading data…',
  spinnerSize = 40,
  className,
  children
}: LoadingOverlayProps) => (
  <div className={cn('loading-overlay', className)}>
    <div className='loading-overlay-background'>{children}</div>
    <div className='loading-overlay-indicator' role='status' aria-live='polite'>
      <Spinner size={spinnerSize} />
      {message && <div className='loading-overlay-message'>{message}</div>}
    </div>
  </div>
);
